const STORAGE_KEY = "scool_data_pdf_appearance_v1";

export const PDF_APPEARANCE_DEFAULT = {
    template: "clean",
    accent: "#111111",
    density: "comfortable",
    showBranding: true,
    showTimestamp: true,
};

const PRESET_ACCENTS = ["#111111", "#374151", "#1f4b99", "#2f6f4e", "#8a3d65", "#8b5a2b"];

const onSafeHex = (value, fallback = "#111111") => {
    const hex = String(value || "").trim();
    return /^#[0-9a-fA-F]{6}$/.test(hex) ? hex.toLowerCase() : fallback;
};

export const onNormalizePdfAppearance = (value = {}) => ({
    template: ["clean", "professional", "technical"].includes(value?.template) ? value.template : PDF_APPEARANCE_DEFAULT.template,
    accent: onSafeHex(value?.accent, PDF_APPEARANCE_DEFAULT.accent),
    density: ["comfortable", "compact"].includes(value?.density) ? value.density : PDF_APPEARANCE_DEFAULT.density,
    showBranding: value?.showBranding !== false,
    showTimestamp: value?.showTimestamp !== false,
});

export const onGetPdfBranding = () => {
    const host = String(window?.location?.host || "").trim();
    const source = host || "Scool Data";
    return {
        product: "Scool Data",
        host,
        source,
        label: host ? `Scool Data · ${host}` : "Scool Data",
    };
};

const onLoadStored = () => {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        return raw ? onNormalizePdfAppearance(JSON.parse(raw)) : PDF_APPEARANCE_DEFAULT;
    } catch {
        return PDF_APPEARANCE_DEFAULT;
    }
};

const onStore = (appearance) => {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(onNormalizePdfAppearance(appearance)));
    } catch {
        // La exportación no debe fallar si el storage del navegador está bloqueado.
    }
};


const onEscapeHtml = (value) => String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

const onEnsureStyles = () => {
    if (window.document.getElementById("scool-data-pdf-appearance-styles")) return;
    const style = window.document.createElement("style");
    style.id = "scool-data-pdf-appearance-styles";
    style.textContent = `
        .NBPdfAppearance__overlay{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.72);display:flex;align-items:center;justify-content:center;padding:24px;font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:#f5f5f5}
        .NBPdfAppearance__modal{width:min(860px,96vw);max-height:min(760px,92vh);overflow:hidden;background:#141414;border:1px solid #343434;border-radius:20px;display:flex;flex-direction:column;box-shadow:0 24px 80px rgba(0,0,0,.45)}
        .NBPdfAppearance__head{display:flex;gap:18px;align-items:flex-start;justify-content:space-between;padding:22px 24px 18px;border-bottom:1px solid #2c2c2c}
        .NBPdfAppearance__head h2{font-size:18px;line-height:1.2;margin:0 0 5px;font-weight:800}.NBPdfAppearance__head p{margin:0;color:#aaa;font-size:13px;line-height:1.45}
        .NBPdfAppearance__close{border:1px solid #3b3b3b;background:#1b1b1b;color:#ddd;width:38px;height:38px;border-radius:11px;cursor:pointer;font-size:20px;line-height:1}
        .NBPdfAppearance__body{display:grid;grid-template-columns:minmax(0,1.2fr) minmax(260px,.8fr);gap:22px;padding:22px 24px;overflow:auto}
        .NBPdfAppearance__section{display:flex;flex-direction:column;gap:11px}.NBPdfAppearance__label{font-size:11px;text-transform:uppercase;letter-spacing:.09em;color:#9d9d9d;font-weight:800}
        .NBPdfAppearance__templates{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px}
        .NBPdfAppearance__template{appearance:none;border:1px solid #333;background:#191919;color:#eee;border-radius:13px;padding:13px;text-align:left;cursor:pointer;min-height:92px}
        .NBPdfAppearance__template[data-active="true"]{border-color:var(--nbpdf-accent);outline:1px solid var(--nbpdf-accent);background:#1d1d1d}.NBPdfAppearance__template strong{display:block;font-size:13px;margin-bottom:5px}.NBPdfAppearance__template span{display:block;color:#9d9d9d;font-size:11px;line-height:1.4}
        .NBPdfAppearance__colors{display:flex;align-items:center;gap:9px;flex-wrap:wrap}.NBPdfAppearance__swatch{width:31px;height:31px;border-radius:9px;border:2px solid #2e2e2e;cursor:pointer}.NBPdfAppearance__swatch[data-active="true"]{outline:2px solid #efefef;outline-offset:2px}.NBPdfAppearance__colorInput{width:48px;height:34px;padding:2px;background:#111;border:1px solid #3b3b3b;border-radius:8px;cursor:pointer}
        .NBPdfAppearance__row{display:flex;gap:8px;flex-wrap:wrap}.NBPdfAppearance__density{appearance:none;border:1px solid #3b3b3b;background:#111;color:#bdbdbd;border-radius:10px;padding:10px 13px;font-size:12px;font-weight:700;cursor:pointer}.NBPdfAppearance__density[data-active="true"]{background:#242424;color:#fff;border-color:var(--nbpdf-accent);outline:1px solid var(--nbpdf-accent)}
        .NBPdfAppearance__checks{display:grid;gap:8px}.NBPdfAppearance__check{display:flex;align-items:center;gap:9px;border:1px solid #303030;background:#181818;border-radius:10px;padding:10px 12px;font-size:12px;color:#d7d7d7}.NBPdfAppearance__check input{width:16px;height:16px;accent-color:var(--nbpdf-accent)}
        .NBPdfAppearance__previewWrap{position:sticky;top:0;align-self:start}.NBPdfAppearance__previewLabel{font-size:11px;text-transform:uppercase;letter-spacing:.09em;color:#9d9d9d;font-weight:800;margin-bottom:11px}.NBPdfAppearance__preview{aspect-ratio:1/1.35;background:#fff;border-radius:10px;padding:18px;color:#171717;overflow:hidden;border:1px solid #363636;box-shadow:0 8px 28px rgba(0,0,0,.28)}
        .NBPdfAppearance__brand{font-size:7px;font-weight:800;letter-spacing:.06em;margin-bottom:14px}.NBPdfAppearance__band{height:15px;margin:-18px -18px 16px;background:var(--nbpdf-accent)}.NBPdfAppearance__preview[data-template="professional"] .NBPdfAppearance__brand{color:white;position:relative;margin-top:-27px;margin-bottom:20px}.NBPdfAppearance__preview[data-template="technical"]{font-family:"Courier New",monospace}.NBPdfAppearance__previewTitle{font-size:18px;font-weight:900;color:var(--nbpdf-accent);text-decoration:underline;text-underline-offset:4px;margin-bottom:7px}.NBPdfAppearance__previewMeta{font-size:7px;color:#6f6f6f;margin-bottom:14px}.NBPdfAppearance__previewSection{font-size:10px;font-weight:900;text-decoration:underline;text-underline-offset:3px;margin:12px 0 8px;color:var(--nbpdf-accent)}.NBPdfAppearance__previewField{font-size:7.5px;line-height:1.7;border-bottom:1px solid #eee;padding:2px 0}.NBPdfAppearance__previewField b{font-weight:900}.NBPdfAppearance__previewFooter{margin-top:17px;padding-top:6px;border-top:1px solid #ddd;color:#777;font-size:6px}
        .NBPdfAppearance__footer{display:flex;justify-content:flex-end;gap:10px;padding:16px 24px;border-top:1px solid #2c2c2c}.NBPdfAppearance__btn{border-radius:10px;padding:10px 16px;font-weight:800;font-size:13px;cursor:pointer;border:1px solid #3a3a3a;background:#1b1b1b;color:#ededed}.NBPdfAppearance__btnPrimary{background:#f2f2f2;color:#111;border-color:#f2f2f2}
        @media(max-width:720px){.NBPdfAppearance__overlay{padding:10px}.NBPdfAppearance__body{grid-template-columns:1fr}.NBPdfAppearance__templates{grid-template-columns:1fr}.NBPdfAppearance__previewWrap{position:static}.NBPdfAppearance__preview{max-width:310px;margin:auto}}
    `;
    window.document.head.appendChild(style);
};

export const requestPdfExportAppearance = ({ title = "Documento" } = {}) => new Promise((resolve) => {
    onEnsureStyles();
    const previous = window.document.querySelector(".NBPdfAppearance__overlay");
    if (previous) previous.remove();

    let state = onNormalizePdfAppearance(onLoadStored());
    const brand = onGetPdfBranding();
    const overlay = window.document.createElement("div");
    overlay.className = "NBPdfAppearance__overlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", "Personalizar apariencia del PDF");

    const templateCards = [
        ["clean", "Limpio", "Blanco, aireado y con títulos claros."],
        ["professional", "Profesional", "Franja superior con color y jerarquía marcada."],
        ["technical", "Técnico", "Más compacto y sobrio para procedimientos y datos."],
    ];

    overlay.innerHTML = `
        <div class="NBPdfAppearance__modal" style="--nbpdf-accent:${state.accent}">
            <div class="NBPdfAppearance__head">
                <div><h2>Personalizar PDF</h2><p>Elegí la estética antes de descargar <strong>${onEscapeHtml(title || "Documento")}</strong>. Los títulos salen en negrita y subrayados; los nombres de campo, en negrita.</p></div>
                <button type="button" class="NBPdfAppearance__close" aria-label="Cerrar">×</button>
            </div>
            <div class="NBPdfAppearance__body">
                <div>
                    <section class="NBPdfAppearance__section">
                        <span class="NBPdfAppearance__label">Estilo</span>
                        <div class="NBPdfAppearance__templates">
                            ${templateCards.map(([key, name, desc]) => `<button type="button" class="NBPdfAppearance__template" data-template="${key}"><strong>${name}</strong><span>${desc}</span></button>`).join("")}
                        </div>
                    </section>
                    <section class="NBPdfAppearance__section" style="margin-top:18px">
                        <span class="NBPdfAppearance__label">Color de acento</span>
                        <div class="NBPdfAppearance__colors">
                            ${PRESET_ACCENTS.map((color) => `<button type="button" class="NBPdfAppearance__swatch" data-color="${color}" style="background:${color}" aria-label="Color ${color}"></button>`).join("")}
                            <input type="color" class="NBPdfAppearance__colorInput" value="${state.accent}" aria-label="Elegir color personalizado" />
                        </div>
                    </section>
                    <section class="NBPdfAppearance__section" style="margin-top:18px">
                        <span class="NBPdfAppearance__label">Composición</span>
                        <div class="NBPdfAppearance__row" role="group" aria-label="Densidad del PDF">
                            <button type="button" class="NBPdfAppearance__density" data-density="comfortable">Espaciado cómodo</button>
                            <button type="button" class="NBPdfAppearance__density" data-density="compact">Compacto</button>
                        </div>
                        <div class="NBPdfAppearance__checks">
                            <label class="NBPdfAppearance__check"><input type="checkbox" data-field="showBranding" /> Mostrar Scool Data + dominio de origen</label>
                            <label class="NBPdfAppearance__check"><input type="checkbox" data-field="showTimestamp" /> Mostrar fecha/hora de exportación</label>
                        </div>
                    </section>
                </div>
                <div class="NBPdfAppearance__previewWrap">
                    <div class="NBPdfAppearance__previewLabel">Vista previa</div>
                    <div class="NBPdfAppearance__preview">
                        <div class="NBPdfAppearance__band"></div>
                        <div class="NBPdfAppearance__brand"></div>
                        <div class="NBPdfAppearance__previewTitle">${onEscapeHtml(title || "Documento")}</div>
                        <div class="NBPdfAppearance__previewMeta">2 pasos · exportación de ejemplo</div>
                        <div class="NBPdfAppearance__previewSection">PASO 1</div>
                        <div class="NBPdfAppearance__previewField"><b>Grupo:</b> Deploy Frontend</div>
                        <div class="NBPdfAppearance__previewField"><b>Estado:</b> Pendiente</div>
                        <div class="NBPdfAppearance__previewField"><b>Comando:</b> npm run build</div>
                        <div class="NBPdfAppearance__previewFooter"></div>
                    </div>
                </div>
            </div>
            <div class="NBPdfAppearance__footer">
                <button type="button" class="NBPdfAppearance__btn" data-action="cancel">Cancelar</button>
                <button type="button" class="NBPdfAppearance__btn NBPdfAppearance__btnPrimary" data-action="export">Descargar PDF</button>
            </div>
        </div>
    `;

    const modal = overlay.querySelector(".NBPdfAppearance__modal");
    const preview = overlay.querySelector(".NBPdfAppearance__preview");
    const brandNode = overlay.querySelector(".NBPdfAppearance__brand");
    const footerNode = overlay.querySelector(".NBPdfAppearance__previewFooter");
    const brandingNode = overlay.querySelector('[data-field="showBranding"]');
    const timestampNode = overlay.querySelector('[data-field="showTimestamp"]');
    const colorInput = overlay.querySelector(".NBPdfAppearance__colorInput");

    const paint = () => {
        modal.style.setProperty("--nbpdf-accent", state.accent);
        preview.dataset.template = state.template;
        overlay.querySelectorAll(".NBPdfAppearance__template").forEach((node) => { node.dataset.active = String(node.dataset.template === state.template); });
        overlay.querySelectorAll(".NBPdfAppearance__swatch").forEach((node) => { node.dataset.active = String(node.dataset.color.toLowerCase() === state.accent.toLowerCase()); });
        overlay.querySelectorAll(".NBPdfAppearance__density").forEach((node) => { node.dataset.active = String(node.dataset.density === state.density); });
        brandingNode.checked = state.showBranding;
        timestampNode.checked = state.showTimestamp;
        colorInput.value = state.accent;
        brandNode.textContent = state.showBranding ? brand.label : "";
        const dateText = state.showTimestamp ? ` · ${new Date().toLocaleString("es-AR")}` : "";
        footerNode.textContent = `${state.showBranding ? brand.label : "Documento"}${dateText} · Página 1 de 1`;
        preview.style.padding = state.density === "compact" ? "14px" : "18px";
    };

    const close = (value) => {
        overlay.remove();
        resolve(value);
    };

    overlay.querySelectorAll(".NBPdfAppearance__template").forEach((node) => node.addEventListener("click", () => {
        state = { ...state, template: node.dataset.template };
        paint();
    }));
    overlay.querySelectorAll(".NBPdfAppearance__swatch").forEach((node) => node.addEventListener("click", () => {
        state = { ...state, accent: onSafeHex(node.dataset.color, state.accent) };
        paint();
    }));
    colorInput.addEventListener("input", (event) => { state = { ...state, accent: onSafeHex(event.target.value, state.accent) }; paint(); });
    overlay.querySelectorAll(".NBPdfAppearance__density").forEach((node) => node.addEventListener("click", () => { state = { ...state, density: node.dataset.density }; paint(); }));
    brandingNode.addEventListener("change", (event) => { state = { ...state, showBranding: event.target.checked }; paint(); });
    timestampNode.addEventListener("change", (event) => { state = { ...state, showTimestamp: event.target.checked }; paint(); });
    overlay.querySelector(".NBPdfAppearance__close").addEventListener("click", () => close(null));
    overlay.querySelector('[data-action="cancel"]').addEventListener("click", () => close(null));
    overlay.querySelector('[data-action="export"]').addEventListener("click", () => {
        const next = onNormalizePdfAppearance(state);
        onStore(next);
        close(next);
    });

    // Intencionalmente NO cerramos por click en backdrop ni por Escape.
    window.document.body.appendChild(overlay);
    paint();
});
